export const ADD_PAYMENT_METHOD = 'ADD_PAYMENT_METHOD'
export const ADD_TAX_ID = 'ADD_TAX_ID'
export const CREATE_BILLING_ACCOUNT = 'CREATE_BILLING_ACCOUNT'
